<template>
  <span class="operation-data-number">{{ currentValue }}</span>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
const props = defineProps({
  targetValue: {
    type: Number,
    required: true
  },
  initialValue: {
    type: Number,
    default: 0
  }
});

const currentValue = ref(props.initialValue);

const scrollToTarget = () => {
  const duration = 500; // 滚动动画时长，单位毫秒
  const startTime = performance.now();
  const startValue = currentValue.value;
  const delta = props.targetValue - startValue;

  const animate = (timestamp) => {
    const elapsed = timestamp - startTime;
    if (elapsed < duration) {
      const progress = elapsed / duration;
      currentValue.value = Math.round(startValue + delta * progress);
      requestAnimationFrame(animate);
    } else {
      currentValue.value = props.targetValue;
    }
  };

  requestAnimationFrame(animate);
};

onMounted(() => {
  scrollToTarget();
});

watch(() => props.targetValue, () => {
  scrollToTarget();
});
</script>

<style scoped>
/* 可根据需要添加样式 */
.operation-data-number {
  font-size: 24px;
  font-weight: bold;
}
</style>